import { Component, inject, Input, Type } from '@angular/core';
import { MpSnackbarTypes } from './mp-snackbar.model';
import { NgClass, NgComponentOutlet, NgIf } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { MpSnackbarRef } from './mp-snackbar-ref.model';
import { MP_SNACKBAR_REF } from './mp-snackbar.tokens';

@Component({
  selector: 'mp-snackbar',
  templateUrl: './mp-snackbar.component.html',
  styleUrls: ['./mp-snackbar.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    NgComponentOutlet,
    TranslateModule
  ],
  animations: [
    trigger('snackbarAnimation', [
      state('void', style({ opacity: 0, transform: 'translateX(-50%) scale(0.5)' })),
      state('*', style({ opacity: 1, transform: 'translateX(-50%) scale(01)' })),
      transition('void => *', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)')
      ]),
      transition('* => void', [
        animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0, transform: 'translateX(-50%) scale(0.5)' }))
      ])
    ])
  ]
})
export class MpSnackbarComponent {
  @Input() message: string;
  @Input() type: MpSnackbarTypes;
  @Input() panelClass: string | string[] = '';

  @Input() innerComponent: Type<any>;

  protected readonly mpSnackbarRef: MpSnackbarRef<MpSnackbarComponent> = inject(MP_SNACKBAR_REF);
}
